import {Box, makeStyles, Typography as MuiTypography} from "@material-ui/core";
import {Helmet} from "react-helmet-async";
import CustomBreadcrumbs from "../components/CustomBreadcrumbs";
import React, {useEffect, useState} from "react";
import {useHistory, useParams} from "react-router-dom";
import {clearCompany, fetchCompany} from "../../../../redux/actions/companyActions";
import {useSelector} from "../../../../redux/store";
import {IUser} from "../../../../models/User";
import {getUserProfile} from "../../../../selectors";
import CompanyForm from "../components/company-form/CompanyForm";
import {useDispatch} from "react-redux";
import {updateCompany, updateCompanyFormData} from "../../../../services/companyService";
import {deepCompareObjects} from "../../../../utils/functions";
import * as types from "../../../../constants";
import {fetchContracts} from "../../../../services/hubspotContractService";
import {IContract} from "../../../../models/Contract";
import {
  createCompanyAPIKey,
  fetchCompaniesAPIKeys, fetchCompaniesAPIKeysByCompany,
  updateCompanyAPIKey
} from "../../../../services/companyAPIKeysService";
import {ICompanyAPIKey} from "../../../../models/CompanyAPIKey";

const useStyles = makeStyles(theme => ({
  title: {
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "20px",
    lineHeight: "24px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
    },
  }
}))

const EditCompanyPage = () => {
  const { id } = useParams<{ id: string }>();
  const history = useHistory();
  const dispatch = useDispatch()
  const styles = useStyles();
  const user = useSelector((state) => state.authReducer.user);
  const userProfile = useSelector<IUser | undefined>(getUserProfile);
  const company = useSelector((state) => state.companyReducer.company);
  const [companyAPIKey, setCompanyAPIKey] = useState<ICompanyAPIKey | null>(null)
  const [loading, setLoading] = useState(false)
  // const [contracts, setContracts] = useState<IContract[] | null >(null)

  useEffect(() => {
    if (userProfile && userProfile.company) {
      dispatch(fetchCompany(id, user!.token));
      // TODO uncomment when we will have contract logic
      // fetchContracts(id, user!.token).then((contractsData: any) => {
      //   setContracts(contractsData)
      // })
    }
  }, [userProfile])

  useEffect(() => {
    if (company) {
      fetchCompaniesAPIKeysByCompany(company.id, user!.token).then((response: any) => {
        if (response && response.length > 0) {
          setCompanyAPIKey(response[response.length - 1])
        } else {
          setCompanyAPIKey({name: company.name, expiry_date: ''})
        }
      })
    }
  }, [company]);

  useEffect(() => {
    return () => {
      dispatch(clearCompany())
    }
  }, []);

  const handleSubmit = (values: any, company: any) => {
    setLoading(true)
    const data: any = deepCompareObjects(company, values)
    if (data) {
      const {logo, company_api_key, ...other} = data
      updateCompany(id, other, user!.token).then(() => {
        if (company_api_key) {
          const companyApiKey = {
            ...company_api_key,
            expiry_date: company_api_key.expiry_date.includes('T') ? company_api_key.expiry_date : `${company_api_key.expiry_date}T00:00:00Z`,
            company: company.id
          }
          if (company_api_key.prefix) {
            updateCompanyAPIKey(
              company_api_key.prefix,
              {name: company_api_key.name, expiry_date: company_api_key.expiry_date},
              user!.token
            )
          } else {
            createCompanyAPIKey(companyApiKey, user!.token)
          }
        }
        if (logo) {
          updateCompanyFormData(id, {logo: logo}, user!.token).then((r) => {
            dispatch({
              type: types.ADD_TOAST,
              payload: {type:'success', message: 'The company has been successfully updated'}
            })
            history.goBack()
            setLoading(false)
          })
        } else {
          dispatch({
            type: types.ADD_TOAST,
            payload: {type: 'success', message: 'The company has been successfully updated'}
          })
          history.goBack()
          setLoading(false)
        }
      }).catch((err) => {
        dispatch({
          type: types.ADD_TOAST,
          payload: {}
        })
        setLoading(false)
      })
    } else {
      setLoading(false)
      history.goBack()
    }
  }

  return (
    <Box p={12}>
      <Helmet title={'Edit company'} />
      <MuiTypography className={styles.title} variant="h3" gutterBottom display="inline">
        Companies list
      </MuiTypography>
      <CustomBreadcrumbs data={[
        {name: 'Companies', link: '/companies'},
        {name: company ? company.name : '', link: `/companies/${id}`}
      ]}/>
      {company && companyAPIKey ? (
        <CompanyForm
          initialValues={JSON.parse(JSON.stringify({...company, company_api_key: companyAPIKey}))}
          onSubmit={(values) => handleSubmit(values, company)}
          loading={loading}
        />
      ) : null}
    </Box>
  )
}

export default EditCompanyPage